export default "__VITE_ASSET__CkszNy06__"